import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const mainDataRouter: Array<RouteRecordRaw> = [
  {
    path: '/mainData',
    component: Layout,
    redirect: 'noredirect',
    meta: {
      order: 1, // 导航栏权重
      title: 'mainDataManagement',
      icon: '#iconyijicaidan',
      roles: [
        'MD_COM_R', 'MD_COM_W',
        'MD_VEN_R', 'MD_VEN_W',
        'MD_EMP_R', 'MD_EMP_W'
      ]
    },
    children: [
      {
        path: 'company',
        redirect: '/mainData/company/list',
        component: () => import(/* webpackChunkName: "companyMainData" */ '@/views/main-data/company/Index.vue'),
        name: 'CompanyIndex',
        meta: {
          title: 'company',
          icon: '#iconerjicaidan',
          roles: ['MD_COM_R', 'MD_COM_W']
        },
        children: [
          {
            path: 'list',
            component: () => import(/* webpackChunkName: "companyMainDataList" */ '@/views/main-data/company/CompanyPageList.vue'),
            name: 'CompanyPageList',
            meta: {
              title: 'company',
              icon: '#iconerjicaidan',
              breadcrumb: false,
              roles: ['MD_COM_R', 'MD_COM_W'],
              keepAlive: true
            }
          },
          {
            path: 'details/:id',
            component: () => import(/* webpackChunkName: "companyDetails" */ '@/views/main-data/company/CompanyDetails.vue'),
            name: 'CompanyDetails',
            meta: {
              title: 'companyDetails',
              hidden: true,
              noCache: true,
              icon: '#iconcaidanitem'
            }
          }
        ]
      },
      {
        path: 'supplier',
        redirect: '/mainData/supplier/list',
        component: () => import(/* webpackChunkName: "supplierIndex" */ '@/views/main-data/supplier/Index.vue'),
        name: 'SupplierIndex',
        meta: {
          title: 'supplier',
          icon: '#iconerjicaidan',
          roles: ['MD_VEN_R', 'MD_VEN_W']
        },
        children: [
          {
            path: 'list',
            component: () => import(/* webpackChunkName: "supplierPage" */ '@/views/main-data/supplier/SupplierPageList.vue'),
            name: 'SupplierPageList',
            meta: {
              title: 'supplier',
              icon: '#iconerjicaidan',
              breadcrumb: false,
              roles: ['MD_VEN_R', 'MD_VEN_W'],
              keepAlive: true
            }
          },
          {
            path: 'supplierCreate',
            component: () => import(/* webpackChunkName: "supplierCreate" */ '@/views/main-data/supplier/SupplierCreate.vue'),
            name: 'SupplierCreate',
            meta: {
              title: 'supplierCreate',
              hidden: true,
              noCache: true,
              icon: '#iconcaidanitem',
              roles: ['MD_VEN_W']
            }
          },
          {
            path: 'supplierUpdate/:id',
            component: () => import(/* webpackChunkName: "supplierUpdate" */ '@/views/main-data/supplier/SupplierUpdate.vue'),
            name: 'SupplierUpdate',
            meta: {
              title: 'supplierUpdate',
              hidden: true,
              noCache: true,
              icon: '#iconcaidanitem',
              roles: ['MD_VEN_W']
            }
          }
        ]
      },
      {
        path: 'employee',
        redirect: '/mainData/employee/list',
        component: () => import(/* webpackChunkName: "employeeIndex" */ '@/views/main-data/employee/Index.vue'),
        name: 'EmployeeIndex',
        meta: {
          title: 'employee',
          icon: '#iconerjicaidan',
          roles: ['MD_EMP_R', 'MD_EMP_W']
        },
        children: [
          {
            path: 'list',
            component: () => import(/* webpackChunkName: "employeePage" */ '@/views/main-data/employee/EmployeePageList.vue'),
            name: 'EmployeePageList',
            meta: {
              title: 'employee',
              icon: '#iconerjicaidan',
              breadcrumb: false,
              roles: ['MD_EMP_R', 'MD_EMP_W'],
              keepAlive: true
            }
          },
          {
            path: 'employeeCreate',
            component: () => import(/* webpackChunkName: "employeeCreate" */ '@/views/main-data/employee/EmployeeCreate.vue'),
            name: 'EmployeeCreate',
            meta: {
              title: 'employeeCreate',
              hidden: true,
              noCache: true,
              icon: '#iconcaidanitem',
              roles: ['MD_EMP_W']
            }
          },
          {
            path: 'employeeUpdate/:id',
            component: () => import(/* webpackChunkName: "employeeUpdate" */ '@/views/main-data/employee/EmployeeUpdate.vue'),
            name: 'EmployeeUpdate',
            meta: {
              title: 'employeeUpdate',
              hidden: true,
              noCache: true,
              icon: '#iconcaidanitem',
              roles: ['MD_EMP_W']
            }
          }
        ]
      }
    ]
  }
]
export default mainDataRouter
